import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SearchBarService } from 'src/app/shared/components/search-bar/search-bar.service';
import { API_URL_COMPANIES, BasicService } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { ExternalAuthorization } from './shared/external-authorization.model';

@Injectable({
  providedIn: 'root',
})
export class ExternalAuthorizationsService {
  constructor(
    private httpClient: HttpClient,
    private searchBarService: SearchBarService,
    private basicService: BasicService,
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService
  ) {}

  findAll(): Observable<HttpResponse<ExternalAuthorization[]>> {
    const body = {
      sort: { active: 'name', direction: 'asc' },
      start: 0,
      range: 9999,
    };

    return this.httpClient
      .post<ExternalAuthorization[]>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/external-authorizations`,
        body,
        { observe: 'response' }
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getExternalAuthorizations = (): Observable<HttpResponse<ExternalAuthorization[]>> => {
    const body = this.searchBarService.buildCriteria();

    return this.httpClient
      .post<ExternalAuthorization[]>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/external-authorizations`,
        body,
        { observe: 'response' }
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  };

  getExternalAuthorization(id: number): Observable<ExternalAuthorization> {
    return this.httpClient
      .get<ExternalAuthorization>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/external-authorizations/${id}`
      )
      .pipe(
        this.errorHandlingService.catchAlertAndThrowHttpError(),
        map((result: ExternalAuthorization) => {
          this.formatExternalAuthorization(result);
          return result;
        })
      );
  }

  formatExternalAuthorization = (externalAuthorization: ExternalAuthorization) => {
    const { creator_admin_user_id } = externalAuthorization;

    const defaultLabel = this.basicService.translate('admin/users/is_admin');
    const getColleagueName = (id: number) => this.alcmeonContextService.getColleague(id)?.realname ?? defaultLabel;

    externalAuthorization.createdByLabel = getColleagueName(creator_admin_user_id);
  };

  saveExternalAuthorization(externalAuthorization: ExternalAuthorization): Observable<any> {
    const { id } = externalAuthorization;
    let call: Observable<any> = this.httpClient.post(
      `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/external-authorizations/create`,
      externalAuthorization
    );
    if (id) {
      call = this.httpClient.put(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/external-authorizations/${id}`,
        externalAuthorization
      );
    }
    return call.pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteExternalAuthorization(id: number) {
    return this.httpClient
      .delete<ExternalAuthorization>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/external-authorizations/${id}`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
